module.exports = __webpack_public_path__ + "img/vtyhv1_center_001.a67be005.png";